<ng-template cdk-connected-overlay
             [cdkConnectedOverlayPush]="true"
             [cdkConnectedOverlayOrigin]="originOverlay"
             [cdkConnectedOverlayOpen]="isOpen"
             [cdkConnectedOverlayLockPosition]="true"
             [cdkConnectedOverlayFlexibleDimensions]="true">
    <div class="popover" [@state]="isOpen ? 'visible' : 'hidden'" (mouseleave)="mouseLeave($event)">
        <ng-content></ng-content>
    </div>
</ng-template>
